import { cloneDeep } from 'lodash-es'
import registerIcps from './shared/registerIcps'

export default {
  errors: {
    required: 'Este campo es requerido',
    doubleFa: {
      codeError: 'El código que indicaste es inválido, inténtalo de nuevo',
    },
    magicLink: {
      emailError: 'Se requiere un correo electrónico válido',
    },
    googleNotAvailable: 'El acceso con Google aún no está disponible para esta cuenta. Para continuar, ingresa tu contraseña.',
  },
  login: {
    needHelp: '¿Necesitas ayuda?',
    title: 'Ingresa a tu cuenta',
    subtitle: 'Sigue ganando tiempo y tranquilidad',
    form: {
      email: {
        label: 'Correo electrónico',
        placeholder: 'Ingresa tu correo electrónico',
      },
      password: {
        label: 'Contraseña',
        placeholder: 'Ingresa tu contraseña',
      },
      forgotPassword: '¿Olvidaste tu contraseña?',
      loginButton: 'Ingresar',
      googleButton: 'Iniciar sesión con Google',
      magicLinkButton: {
        label: 'Ingresar desde mi correo',
        tooltip: 'Recibe un link para ingresar sin contraseña.',
      },
    },
    footer: {
      dontHaveAccount: '¿Aún no tienes una cuenta?',
      signUp: 'Regístrate gratis',
      allProducts: 'Ingresa con las mismas credenciales a todos los productos de Alegra.',
    },
  },
  register: {
    title: '¡Alegra es gratis por 15 días!',
    titleAlliance: 'Crea tu cuenta gratis',
    form: {
      email: {
        label: 'Correo electrónico',
        placeholder: 'Ingresa tu correo electrónico',
      },
      password: {
        label: 'Contraseña',
        placeholder: 'Ingresa una contraseña',
      },
      coupon: {
        label: '¿Tienes un código promocional?',
        placeholder: 'Ingrésalo aquí',
      },
      registerButton: 'Crear cuenta',
      googleButton: 'Regístrate con Google',
      magicLinkButton: {
        label: 'Regístrate desde tu correo',
        tooltip: 'Recibe un link para registrarte sin contraseña.',
      },
    },
    footer: {
      haveAccount: '¿Ya tienes una cuenta?',
      login: 'Inicia sesión',
      accept: 'Acepto los',
      terms: 'Términos y Condiciones',
      authorize: 'y autorizo el',
      dataTreatment: 'Tratamiento de mis datos personales',
    },
  },
  registerEducationAlliance: {
    title: '¡Aquí empieza tu alianza educativa con Alegra! 🎓',
    form: {
      registerButton: 'Crear cuenta',
      information: {
        title: 'Esta cuenta es educativa',
        description:
          'Si no perteneces a una alianza educativa o deseas usar Alegra para tu negocio, crea una cuenta ',
      },
    },
  },
  doubleFA: {
    title: 'Autenticación en dos pasos',
    subtitle: 'Incluye el código de 6 dígitos generado en tu app de autenticación.',
    noAskForCode: 'No pedir código en este navegador',
    getIntoButton: 'Ingresar',
    anotherOption: '¿Necesitas otra opción para autenticarte?',
    backupCodeTitle: 'Ingreso con código de respaldo',
    backupCodeSubtitle: 'Usa uno de tus códigos de respaldo para autenticarte.',
    unableToAuth: '¿Sigues sin poder autenticarte?',
    contactSupport: 'Contactar a soporte',
  },
  passwordUpdate: {
    title: 'Mantén tu cuenta segura',
    subtitle:
      'Necesitas actualizar tu contraseña para reforzar tu seguridad, enviamos a <b>{email}</b> los pasos para cambiarla e iniciar sesión.',
    subtitleNoProvider:
      'Necesitas actualizar tu contraseña para reforzar tu seguridad. Enviamos a <b>{email}</b> los pasos para cambiarla e iniciar sesión, puedes buscarlos en tu bandeja de entrada o spam.',
    footer: '¿No recibiste el correo?',
    footerContactUs: 'Contáctanos',
    modal: {
      title: '¿Necesitas ayuda?',
      subtitle: 'Estas son las opciones de soporte disponibles para ti',
      form: {
        title: 'Envíanos un correo',
        text: 'Nuestra bandeja de entrada está disponible 24/7 para ayudarte con tu solicitud.',
      },
      chat: {
        title: 'Habla con un agente por chat',
        text: 'Nuestros agentes están disponibles de lunes a viernes de {start} a {end}.',
      },
      call: {
        title: 'Llama a un agente',
        text: 'Encuentra el número de soporte para tu país, horario de atención y llámanos.',
      },
    },
  },
  magicLink: {
    login: {
      main: {
        title: '¡Ingresa desde tu correo!',
        subtitle: 'Usa un link mágico para ingresar sin contraseña.',
        sendButton: 'Enviar link mágico',
        backButton: 'Ingresar con otro método',
      },
      sended: {
        title: '¡Te enviamos un link mágico!',
        subtitle:
          'Búscalo en tu bandeja de entrada o revisa si llegó a la carpeta de spam <br class="hidden md:block" /><b>{email}</b>',
        resendButton: 'Reenviar link',
      },
      resended: {
        title: '¡Reenviamos tu link mágico!',
        titleMultipleTimes: 'Enviaste 5 links en la última hora',
        text: 'Podrás solicitar otro link en:',
        textTime:
          'Puedes usar otro método para iniciar sesión o solicitar un nuevo link a las {time}',
        actionButton: 'Iniciar sesión con correo y contraseña',
      },
    },
    signup: {
      main: {
        title: '¡Regístrate desde tu correo!',
        subtitle: 'Usa un link mágico para registrarte sin contraseña.',
        sendButton: 'Enviar link mágico',
        backButton: 'Registrarme con otro método',
      },
      sended: {
        title: '¡Te enviamos un link mágico!',
        subtitle:
          'Búscalo en tu bandeja de entrada o revisa si llegó a la carpeta de spam <br class="hidden md:block" /><b>{email}</b>',
        resendButton: 'Reenviar link',
      },
      resended: {
        title: '¡Reenviamos tu link mágico!',
        titleMultipleTimes: 'Enviaste 5 links en la última hora',
        text: 'Podrás solicitar otro link en:',
        textTime: 'Puedes usar otro método para registrarte o solicitar un nuevo link a las {time}',
        actionButton: 'Registrarme con correo y contraseña',
      },
    },
    expired: {
      title: '¡Tu link mágico caducó!',
      subtitle:
        'Ten en cuenta que el tiempo de disponibilidad es de <b>30 minutos</b> y solo puede ser usado una vez.',
      sendButton: 'Enviar un nuevo link',
      backButton: 'Ingresar con otro método',
    },
    form: {
      email: {
        label: 'Correo electrónico',
        placeholder: 'Indica tu correo electrónico',
      },
    },
  },
  recoverPassword: {
    request: {
      title: '¿No puedes ingresar a tu cuenta?',
      subtitle: 'Restablece tu contraseña',
      message:
        'Enviamos las instrucciones para <br/>restablecer tu contraseña al correo<br/> <b>{email}</b>',
      resetButton: 'Restablecer',
      backButton: 'Volver a inicio de sesión',
      footer: {
        haveAccount: '¿Aún no tienes una cuenta?',
        createAccount: 'Crear cuenta',
      },
    },
    change: {
      title: 'Restablece tu contraseña',
      subtitle: 'Por favor, crea tu nueva contraseña.',
      createPasswordButton: 'Crear contraseña',
      backButton: 'Volver a inicio de sesión',
      form: {
        validate: 'Validando información..',
        answerOk: {
          title: '¡Contraseña actualizada!',
          subtitle: 'Te llevaremos de vuelta a tu cuenta.',
        },
      },
    },
  },
  validateIdentity: {
    request: {
      title: 'Verificación de acceso',
      description: 'Por seguridad, selecciona una opción para confirmar tu identidad.',
      options: {
        whatsapp: {
          label: 'WhatsApp',
          placeholder: 'Te enviaremos un código de seguridad a tu número de WhatsApp.',
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Te enviaremos un código de seguridad a tu correo electrónico principal.',
        },
      },
    },
    requestWhatsApp: {
      title: 'Verificación vía WhatsApp',
      description: 'Ingresa los últimos 4 dígitos de tu número de WhatsApp.',
    },
    otp: {
      title: 'Ingresa el código de seguridad',
      description: {
        whatsapp: 'Revisa tu WhatsApp e ingresa el código de 6 dígitos.',
        email: 'Revisa el correo {email} e ingresa el código de 6 dígitos para continuar.',
      },
      errorCode: 'El código es incorrecto. Te {attempts}.',
    },
    temporarilyBlocked: {
      title: 'Acceso suspendido temporalmente',
      description:
        'Por tu seguridad, hemos suspendido el acceso después de 3 intentos fallidos. Por favor, contacta a soporte para ingresar a tu cuenta.',
      options: {
        email: {
          label: 'Escríbenos por correo',
          placeholder: 'Estamos disponibles 24/7 para ayudarte.',
        },
        chat: {
          label: 'Habla con un agente',
          placeholder: 'Nuestro equipo te atenderá de lunes a viernes de {start} a {end}.',
        },
      },
      info: 'Este bloqueo es <b>temporal</b>. Tu información sigue 100% protegida en Alegra.',
    },
  },
  registerIcps: cloneDeep(registerIcps),
}
